var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fc-org-select" },
    [
      _c(
        "div",
        { staticClass: "tags" },
        [
          _vm.buttonType === "button"
            ? _c(
                "el-button",
                {
                  staticStyle: { "margin-bottom": "6px" },
                  attrs: {
                    size: "small",
                    type: "primary",
                    icon: "el-icon-plus",
                  },
                  on: {
                    click: function ($event) {
                      _vm.show = true
                    },
                  },
                },
                [_vm._v("\n      添加" + _vm._s(_vm.title) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "input-box",
              class: { "as-input": _vm.buttonType === "input" },
              on: {
                click: function ($event) {
                  _vm.show = true
                },
              },
            },
            _vm._l(_vm.selectedData, function (item) {
              return _c(
                "el-tag",
                _vm._b(
                  {
                    key: item.key,
                    staticClass: "org-tag",
                    on: {
                      close: function ($event) {
                        return _vm.onClose(item)
                      },
                    },
                  },
                  "el-tag",
                  _vm.tagConfig,
                  false
                ),
                [_vm._v("\n        " + _vm._s(item.label) + "\n      ")]
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("fc-org-transfer", {
        ref: "transfer",
        attrs: {
          value: _vm.innerValue,
          title: _vm.title,
          searchable: _vm.searchable,
          "max-num": _vm.maxNum,
          "tab-list": _vm.tabList,
          show: _vm.show,
        },
        on: {
          "update:show": function ($event) {
            _vm.show = $event
          },
          confirm: _vm.onConfirm,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }